
import React from 'react';
import '../BulkUpload/BulkUploadContent.scss';
import {
  CoreUploader
} from '@komodo-design-system/komodo-components-react';
import { UploadedFile } from '@komodo-design-system/komodo-core-web-components';
import AssetTypeSelector from '../UploadContent/AssetTypeSelector';
import { useSelector } from 'react-redux';

interface SingleUploadContentFilesProps {
  setAssetType: (value: any) => void
  asstType: { value: string; label: string };
  uploadFile: (event: CustomEvent<UploadedFile[]>) => void;
  files: UploadedFile[];
  setFiles: (files: UploadedFile[]) => void;
  assetTypeKey?: string;
}

const SingleUploadContentFiles: React.FC<SingleUploadContentFilesProps> = ({ setAssetType, asstType, uploadFile, files, setFiles,assetTypeKey }) => {
  const assetTypes = useSelector(
    (state: any) => state.assetTypeReducer?.assetTypes
  );
  const defaults = assetTypes?.metadata_collection?.MODEL_DEFAULTS || {};
  const isMetaDataOnly = assetTypeKey ? defaults[assetTypeKey]?.is_metadata_only : true;

  return (
    <div className="bulk-upload-content" style={{ marginBottom: '73px' }}>
      <AssetTypeSelector asstType={asstType} setAssetType={setAssetType} />
      {!isMetaDataOnly && <CoreUploader
        style={{ top: '10px', position: 'relative' }}
        className={files.length > 0 ? 'uploader' : ''}
        files={files}
        limitone
        showicon
        variant="full-size"
        onFileListUpdated={uploadFile}
        closeFileCallback={() => setFiles([])}></CoreUploader>
      }
    </div>
  );
};

export default SingleUploadContentFiles;
